import React from 'react';
import { Grid } from '@material-ui/core';
import { Field } from 'formik';
import { TextField } from 'components/FormFields';
import { useStyles } from './commonStyles';
import i18n from 'i18n-js';
import InputAdornment from '@material-ui/core/InputAdornment';

const BasicInformationInputs = ({ values, errors }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.container}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Field
            margin="none"
            label={i18n.t('common.name')}
            name="name"
            asyncErrors={errors.name}
            component={TextField}
            data-cy="credit-type-name-input"
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Field
            margin="none"
            label={i18n.t('common.description')}
            name="description"
            asyncErrors={errors.description}
            component={TextField}
            required={false}
            data-cy="credit-type-description-input"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            min={1}
            step="any"
            type="number"
            margin="none"
            format="price"
            label={i18n.t('common.default_price')}
            name="default_unit_price"
            asyncErrors={errors.default_unit_price}
            component={TextField}
            startAdornment={
              <InputAdornment position="start" style={{ marginRight: -8 }}>
                $
              </InputAdornment>
            }
            data-cy="credit-type-default_unit_price-input"
          />
          <span className={classes.priceDescription}>
            {i18n.t('credit_types.default_price_description')}
          </span>
        </Grid>
      </Grid>
    </Grid>
  );
};

export { BasicInformationInputs };
